import { c as _c } from "react/compiler-runtime";
import { shortDayShortMonth } from 'utils/DateFormats';
import type { AccessTimesProps } from './AccessTimes.types';
const AccessTimes = t0 => {
  const $ = _c(23);
  const {
    type,
    startDate,
    endDate,
    startTime,
    endTime
  } = t0;
  const t1 = type === "accommodation" ? "Check-in" : "Opens";
  let t2;
  if ($[0] !== t1) {
    t2 = <dt className="typography-chip-style text-neutral-600">{t1}</dt>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== startDate) {
    t3 = startDate && <dd className="typography-emphasis-2">{shortDayShortMonth(startDate)}</dd>;
    $[2] = startDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== startTime) {
    t4 = <dd className="typography-subtitle-2">{startTime}</dd>;
    $[4] = startTime;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className="grow">{t2}{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = type === "accommodation" ? "Check-out" : "Closes";
  let t7;
  if ($[10] !== t6) {
    t7 = <dt className="typography-chip-style text-neutral-600">{t6}</dt>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== endDate) {
    t8 = endDate && <dd className="typography-emphasis-2">{shortDayShortMonth(endDate)}</dd>;
    $[12] = endDate;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== endTime) {
    t9 = <dd className="typography-subtitle-2">{endTime}</dd>;
    $[14] = endTime;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className="border-l grow pl-20px border-neutral-300">{t7}{t8}{t9}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <dl className="flex mb-24px">{t5}{t10}</dl>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export { AccessTimes };